// Банки в розділі «Банки». ready — є майстер під'єднання; решта — у підготовці (спосіб доступу в note).
// Відкритий банкінг (згода клієнта, положення НБУ № 80 з 01.08.2025) уже підтримують monobank (Універсал Банк), ПУМБ,
// A-Банк і Глобус — їхні рахунки додаються в Приват24 (finclub.net, 22.10.2026). За висновком юриста (22.10.2026)
// окремого дозволу НБУ для доступу eCabinet через відкриті API до рахунку не потрібно. Прямі API: ПриватБанк
// «Автоклієнт» (токен створює клієнт), monobank corporate
// (погодження банку, клієнт підтверджує за посиланням), ПУМБ — лише партнерські інтеграції, Глобус — не знайдено
// Логотипи — офіційні: іконки застосунків банків з App Store (A-Банк «àbank24», monobank, «ПУМБ Бізнес») і логотипи
// з сайтів банків (globusbank.com.ua, privatbank.ua); лише для позначення банку в каталозі
import abank from "./logos/abank.png";
import monobank from "./logos/monobank.png";
import pumb from "./logos/pumb.png";
import globus from "./logos/globus.png";
import privatbank from "./logos/privatbank.png";

export const BANKS = [
  { key: "abank", logo: abank, title: "A-Банк", ready: true,
    note: "Open API клієнт-банку «А-Бізнес»: підтвердження в застосунку й активація банком. Рахунки й залишки, далі — виписки." },
  { key: "monobank", logo: monobank, title: "monobank · Універсал Банк", ready: false,
    note: "API для сервісів (corporate): банк погоджує eCabinet, ви підтверджуєте доступ за посиланням у застосунку monobank." },
  { key: "pumb", logo: pumb, title: "ПУМБ", ready: false,
    note: "Відкритий банкінг або партнерська інтеграція з банком: доступ до виписок за вашою згодою." },
  { key: "globus", logo: globus, title: "Банк «Глобус»", ready: false,
    note: "Відкритий банкінг: доступ до рахунків за вашою згодою (уточнюємо з банком)." },
  { key: "privatbank", logo: privatbank, title: "ПриватБанк", ready: false,
    note: "Приват24 для бізнесу → «Інтеграція (Автоклієнт)»: токен створюєте ви, eCabinet читає залишки й виписки." },
];
